<div class="specific-container">
    <div class="comp-instance-os">
        <div class="image-os">
            <img src="{{ item.result.osIconLocation }}" width="18px" height="18px" alt="{{item.result.osLabel}}" />
        </div>
    </div>
    <div class="comp-instance-name">
        {{ item.result.nameShort }}
    </div>
    <div class="comp-instance-data-center">
        {{ item.result.datacenterLabel }}
    </div>
    <div class="comp-instance-class">
        {{ item.result.class | formatNullableValue }}
    </div>
    <div class="comp-instance-cpu">
        {{ item.result.numberCpu }} CPU
    </div>
    <div class="comp-instance-memory">
        {{ item.result.memorySizeMb | formatToBestUnit : bytesMibi }}
    </div>
    <div class="comp-instance-disk">
        {{ item.result.allocatedDiskGb | formatToBestUnit:3:0 }}
    </div>
    <div class="comp-instance-replication-tier">
        {{ item.result.replicationTier }}
    </div>
</div>
